<!-- Expanded Modal Backdrop -->
<div *ngIf="progressState.show && isExpanded"
     class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
     (click)="onMinimize()">

  <!-- Modal Content -->
  <div class="bg-white rounded-lg shadow-xl max-w-md w-full p-6"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="flex items-center justify-between mb-6">
      <h3 class="text-lg font-semibold text-gray-900 flex items-center">
        <i class="fas fa-file-invoice text-blue-600 mr-2"></i>
        {{ progressState.title }}
      </h3>
      <div class="flex items-center gap-2">
        <button
          (click)="onMinimize()"
          class="text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Minimize">
          <i class="fas fa-minus text-lg"></i>
        </button>
        <button
          (click)="onClose()"
          class="text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close">
          <i class="fas fa-times text-xl"></i>
        </button>
      </div>
    </div>

    <!-- Progress Bar -->
    <div class="mb-6">
      <div class="flex items-center justify-between text-sm text-gray-600 mb-2">
        <span>{{ progressState.currentMessage }}</span>
        <span class="font-semibold">{{ progressState.progress }}%</span>
      </div>
      <div class="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
        <div class="bg-blue-600 h-full transition-all duration-300 ease-out"
             [style.width.%]="progressState.progress">
        </div>
      </div>
    </div>

    <!-- Stages List -->
    <div class="space-y-3">
      <div *ngFor="let stage of progressState.stages; let i = index"
           class="flex items-start gap-3 p-3 rounded-lg transition-colors"
           [class.bg-blue-50]="stage.status === 'in-progress'"
           [class.bg-green-50]="stage.status === 'completed'">

        <!-- Stage Icon -->
        <div class="flex-shrink-0 mt-0.5">
          <i class="fas text-lg transition-all"
             [ngClass]="[getStageIcon(stage), getStageClass(stage)]"></i>
        </div>

        <!-- Stage Info -->
        <div class="flex-1 min-w-0">
          <div class="font-medium text-gray-900">{{ stage.name }}</div>
          <div *ngIf="stage.message" class="text-sm text-gray-600 mt-0.5">
            {{ stage.message }}
          </div>
        </div>

        <!-- Stage Status Badge -->
        <div *ngIf="stage.status === 'completed'"
             class="flex-shrink-0">
          <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
            Done
          </span>
        </div>
        <div *ngIf="stage.status === 'in-progress'"
             class="flex-shrink-0">
          <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
            Running
          </span>
        </div>
      </div>
    </div>

    <!-- Footer Note -->
    <div class="mt-6 p-3 bg-gray-50 rounded-lg">
      <p class="text-xs text-gray-600">
        <i class="fas fa-info-circle mr-1"></i>
        You can safely navigate away. The generation will continue in the background.
      </p>
    </div>
  </div>
</div>

<!-- Minimized Widget (Bottom Right) -->
<div *ngIf="progressState.show && !isExpanded"
     class="fixed right-6 z-[60]"
     style="bottom: 93px;">

  <div (click)="onExpand()"
       class="bg-white rounded-lg shadow-lg border border-gray-200 p-4 cursor-pointer hover:shadow-xl transition-shadow w-80">

    <!-- Header -->
    <div class="flex items-center justify-between mb-3">
      <div class="flex items-center gap-2">
        <i class="fas fa-file-invoice text-blue-600"></i>
        <span class="font-medium text-gray-900 text-sm">{{ progressState.title }}</span>
      </div>
      <button
        (click)="onClose(); $event.stopPropagation()"
        class="text-gray-400 hover:text-gray-600 transition-colors"
        aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Progress Bar -->
    <div class="mb-2">
      <div class="flex items-center justify-between text-xs text-gray-600 mb-1.5">
        <span class="truncate flex-1 mr-2">{{ progressState.currentMessage }}</span>
        <span class="font-semibold">{{ progressState.progress }}%</span>
      </div>
      <div class="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
        <div class="bg-blue-600 h-full transition-all duration-300 ease-out"
             [style.width.%]="progressState.progress">
        </div>
      </div>
    </div>

    <!-- Current Stage -->
    <div *ngIf="progressState.currentStageIndex < progressState.stages.length"
         class="flex items-center gap-2 text-xs text-gray-600 mt-2">
      <i class="fas fa-spinner fa-spin text-blue-600"></i>
      <span>{{ progressState.stages[progressState.currentStageIndex].name }}</span>
    </div>

    <!-- Click to expand hint -->
    <div class="text-xs text-gray-400 mt-2 text-center">
      Click to expand
    </div>
  </div>
</div>
